import { AlpineComponent } from '@alpinejs/csp';

export const Accordion = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'accordion__wrapper--visible' : '';
  }
});

export const AccordionItem = (): AlpineComponent => ({
  expanded: false,

  init() {
    this.expanded = this.$root.getAttribute('data-expanded') === 'true';
  },

  toggleItem() {
    this.expanded = !this.expanded;
  }
});
